// Format phone number as user types (only digits, spaces, hyphens)
export const formatPhoneNumber = (value: string): string => {
  if (!value) return '';

  // Allow only digits, spaces, and hyphens
  return value.replace(/[^\d\s-]/g, '');
};

// Format phone number for CRM submission (country code + digits only)
export const formatPhoneForCRM = (countryCode: string, phoneNumber: string): string => {
  if (!phoneNumber) return '';

  // Remove all non-numeric characters from phone number
  const cleanPhone = phoneNumber.replace(/\D/g, '');

  if (!cleanPhone) return '';

  // Return country code + clean phone number
  return `${countryCode}${cleanPhone}`;
};

// Validate phone number - minimum 7 digits
export const isValidPhoneNumber = (value: string): boolean => {
  if (!value) return false;

  const digits = value.replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
};